


















































































































































































































































































































































































































































































































































































// import Vue from 'vue'
// import Component from 'vue-class-component'

import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import { State, Getter, Action } from 'vuex-class'


import DigitalCurrency1DigitalCurrencySymbol from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-1-digital-currency-symbol.vue'
// import DigitalCurrency2SendPaymentButton from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-2-send-payment-button.vue'
import DigitalCurrency6AccountUserProfilePicture from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-6-account-user-profile-picture.vue'
// import DigitalCurrency7AccountBalanceNumberWithIcon from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-7-account-balance-number-with-icon.vue'
// import DigitalCurrency9AccountShortIntroductionButton from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-9-account-short-introduction-button.vue'
// import DigitalCurrency11QrCodeScannerButton from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-11-qr-code-scanner-button.vue'
// import DigitalCurrency15AccountSettingsButton from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-15-account-settings-button.vue'

// import Groups1AddToGroupButton from '../../../../html-components-type-1-basic/basic-type-5-groups/groups-1-add-to-group-button.vue'


import DigitalCurrency5AccountThumbnail from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-5-account-thumbnail.vue'

import DigitalCurrencyTransaction1TransactionShortIntroductionButton from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/service-for-digital-currency-transaction/-1-transaction-short-introduction-button.vue'
import DigitalCurrencyTransaction3CopyTransactionButton from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/service-for-digital-currency-transaction/-3-copy-transaction-button.vue'
import DigitalCurrencyTransaction4TransactionSettingsButton from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/service-for-digital-currency-transaction/-4-transaction-settings-button.vue'
import DigitalCurrencyTransaction6TransactionStartAndStopSubscriptionButton from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/service-for-digital-currency-transaction/-6-transaction-start-and-stop-subscription-button.vue'
import DigitalCurrencyTransaction8DeleteTransactionButton from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/service-for-digital-currency-transaction/-8-delete-transaction-button.vue'

import DigitalCurrency20AnimatedCurrencyLabel from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-20-animated-currency-label.vue'

import { projectVariables } from '../../../../../../../../../../service-for-environment-variables/environment-variables-type-1-general-variables/general-variables-type-1-project-variables/project-variables-1-introduction'

import { getTimeUntilMillisecondDurationReached } from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/service-for-helper-algorithms/helper-algorithms-4-get-time-until-millisecond-duration-reached'
import { getDigitalCurrencyAmountWithCommaSeparatedValue } from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/service-for-helper-algorithms/helper-algorithms-2-get-digital-currency-amount-with-comma-separated-value'
import { getTransactionProcessingInformationTableAlgorithm } from '../../../../../../../../../../service-for-game-codebase/game-codebase-type-1-app/app-type-3-digital-currency-transaction/digital-currency-transaction-type-1-algorithms/algorithms-type-9-initialize-digital-currency-transaction-list/service-for-helper-algorithms/helper-algorithms-1-get-transaction-processing-information-table'

import { DigitalCurrencyTransaction, SPECIAL_TRANSACTION_TYPE_UNIVERSAL_BASIC_INCOME } from '../../../../../../../../../../service-for-game-codebase/game-codebase-type-1-app/app-type-3-digital-currency-transaction/digital-currency-transaction-type-2-data-structures/data-structures-type-1-transaction/transaction-1'

import { NUMBER_OF_MILLISECONDS_IN_A_MINUTE } from '../../../../../../../../../../service-for-game-codebase/game-codebase-type-1-app/app-type-1-general/general-type-3-constants/constants-3-time'

import {
  DataTableFile,
  itemTypeAccount
} from '../../../../html-components-type-1-basic/basic-type-4-user-interface/service-for-data-structures/data-structures-1-file-system-data-structure'

import moment from 'moment'


const namespace = 'digitalCurrency'

@Component({
  components: {
    DigitalCurrency5AccountThumbnail,
    DigitalCurrency1DigitalCurrencySymbol,
    // DigitalCurrency2SendPaymentButton,
    DigitalCurrency6AccountUserProfilePicture,
    // DigitalCurrency7AccountBalanceNumberWithIcon,
    // DigitalCurrency9AccountShortIntroductionButton,
    // DigitalCurrency11QrCodeScannerButton,
    // DigitalCurrency15AccountSettingsButton,
    // Groups1AddToGroupButton

    DigitalCurrencyTransaction1TransactionShortIntroductionButton,
    DigitalCurrencyTransaction3CopyTransactionButton,
    DigitalCurrencyTransaction4TransactionSettingsButton,
    DigitalCurrencyTransaction6TransactionStartAndStopSubscriptionButton,
    DigitalCurrencyTransaction8DeleteTransactionButton,

    DigitalCurrency20AnimatedCurrencyLabel
  }
})
class TransactionHelperComponents2Header extends Vue {
  @State('isMobileDevice') isMobileDevice?: boolean

  @Prop({ default: '' }) transactionId?: string
  @Prop({ default: true }) openWebsitePageInNewTab?: boolean

  @Prop({ default: '' }) transactionOwnerAccountId?: string

  @Getter('getActiveDigitalCurrencyAccount', { namespace }) getActiveDigitalCurrencyAccount?: any
  @Getter('getDigitalCurrencyTransaction', { namespace }) getDigitalCurrencyTransaction?: any
  @Getter('getDigitalCurrencyAccount', { namespace }) getDigitalCurrencyAccount?: any

  @Action('getDigitalCurrencyAccountById', { namespace }) getDigitalCurrencyAccountById?: any

  @Action('addEventListenerToDigitalCurrencyTransaction', { namespace }) addEventListenerToDigitalCurrencyTransaction?: any
  @Action('removeEventListenerFromDigitalCurrencyTransaction', { namespace }) removeEventListenerFromDigitalCurrencyTransaction?: any

  @Action('serviceInformation1GetServiceInformationByDaemonStatus') serviceInformation1GetServiceInformationByDaemonStatus?: any

  temporaryImageUrl: string = 'https://ecoin-static-file-host.web.app/service-for-game-introduction/game-introduction-type-1-web-browser-introduction/web-browser-introduction-type-1-customer-website/public/img/icons/android-chrome-512x512.png'
  temporaryImageUrl2: string = 'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fpixy.org%2Fsrc%2F21%2F219269.jpg&f=1&nofb=1'

  projectName = projectVariables.projectName
  digitalCurrencyName = projectVariables.digitalCurrencyName
  digitalCurrencySymbolImageIconUrl = projectVariables.digitalCurrencySymbolImageIconUrl
  projectImageIconUrl = projectVariables.projectImageIconUrl
  projectImageIconUrl2 = projectVariables.projectImageIconUrl2

  isInitializedTransactionAccountList: boolean = false

  transactionEventListenerId: string = ''

  dateUntilNextProcessing: any = ''
  dateUntilNextProcessingIntervalId: any = ''

  isActiveServiceDaemon: boolean = false
  isActiveServiceDaemonIntervalId: any = ''

  expectedNumberOfTimesProcessedForSpecialTransactionType: number = 0
  expectedNumberOfTimesProcessedForSpecialTransactionTypeIntervalId: any = ''

  showRecurringTransactionInformationDialog: boolean = false

  SPECIAL_TRANSACTION_TYPE_UNIVERSAL_BASIC_INCOME = SPECIAL_TRANSACTION_TYPE_UNIVERSAL_BASIC_INCOME

  getTimeUntilMillisecondDurationReached = getTimeUntilMillisecondDurationReached
  getDigitalCurrencyAmountWithCommaSeparatedValue = getDigitalCurrencyAmountWithCommaSeparatedValue

  @Watch('transactionId') async onUpdateTransactionId () {
    await this.initializeEventListener()
    await this.initializeTransactionAccountList()
    await this.initializeDateUntilNextProcessing()
    this.initializeExpectedNumberOfTimesProcessedForSpecialTransactionType()
  }

  async mounted () {
    await this.onUpdateTransactionId()
    await this.initializeGetIsActiveServiceDaemon()
  }

  async destroyed () {
    await this.removeEventListenerFromDigitalCurrencyTransaction({
      digitalCurrencyTransactionId: this.transactionId,
      eventListenerId: this.transactionEventListenerId
    })

    if (this.dateUntilNextProcessingIntervalId) {
      clearInterval(this.dateUntilNextProcessingIntervalId)
    }

    clearInterval(this.isActiveServiceDaemonIntervalId)
    clearInterval(this.expectedNumberOfTimesProcessedForSpecialTransactionTypeIntervalId)
  }

  async initializeEventListener () {
    if (!this.transactionId) {
      return
    }

    if (this.transactionEventListenerId) {
      await this.removeEventListenerFromDigitalCurrencyTransaction({
        digitalCurrencyTransactionId: this.transactionId,
        eventListenerId: this.transactionEventListenerId
      })
    }

    this.transactionEventListenerId = await this.addEventListenerToDigitalCurrencyTransaction({
      digitalCurrencyTransactionId: this.transactionId
    })
  }

  async initializeTransactionAccountList () {
    if (!this.transactionId || this.isInitializedTransactionAccountList) {
      return
    }

    const digitalCurrencyTransaction = this.getDigitalCurrencyTransaction(this.transactionId)

    if (!digitalCurrencyTransaction) {
      return
    }

    if (digitalCurrencyTransaction.specialTransactionType) {
      return
    }

    await this.getDigitalCurrencyAccountById(digitalCurrencyTransaction.accountSenderId)

    for (let accountRecipientId in digitalCurrencyTransaction.accountRecipientIdVariableTable) {
      if (!digitalCurrencyTransaction.accountRecipientIdVariableTable.hasOwnProperty(accountRecipientId)) {
        continue
      }
      await this.getDigitalCurrencyAccountById(accountRecipientId)
    }

    this.isInitializedTransactionAccountList = true
  }

  async initializeDateUntilNextProcessing () {
    if (!this.transactionId) {
      return
    }

    let digitalCurrencyTransaction: DigitalCurrencyTransaction = this.getDigitalCurrencyTransaction(this.transactionId)

    if (!digitalCurrencyTransaction) {
      return
    }

    if (!digitalCurrencyTransaction.isRecurringTransaction) {
      return
    }

    if (this.dateUntilNextProcessingIntervalId) {
      clearInterval(this.dateUntilNextProcessingIntervalId)
    }

    this.dateUntilNextProcessingIntervalId = setInterval(() => {
      digitalCurrencyTransaction = this.getDigitalCurrencyTransaction(this.transactionId)
      const { dateTransactionRecurred, dateTransactionScheduledToBeProcessed } = getTransactionProcessingInformationTableAlgorithm.function(digitalCurrencyTransaction)
      const currentDate = (new Date()).getTime()

      const hasScheduledDateEnded = dateTransactionScheduledToBeProcessed.getTime() < currentDate
      let millisecondDelayUntilNextProcessing = 0

      if (!hasScheduledDateEnded) {
        millisecondDelayUntilNextProcessing = dateTransactionScheduledToBeProcessed.getTime() - currentDate
      } else {
        if (dateTransactionRecurred.getTime() > currentDate) {
          millisecondDelayUntilNextProcessing = Math.abs((dateTransactionRecurred.getTime() + digitalCurrencyTransaction.millisecondRecurringDelay) - currentDate) % digitalCurrencyTransaction.millisecondRecurringDelay
        } else {
          millisecondDelayUntilNextProcessing = digitalCurrencyTransaction.millisecondRecurringDelay - Math.abs((dateTransactionRecurred.getTime() + digitalCurrencyTransaction.millisecondRecurringDelay) - currentDate) % digitalCurrencyTransaction.millisecondRecurringDelay
        }
      }

      this.dateUntilNextProcessing = getTimeUntilMillisecondDurationReached(millisecondDelayUntilNextProcessing || 0)
    }, 1000)
  }

  async openAccount (accountId: string) {
    const digitalCurrencyAccount = await this.getDigitalCurrencyAccount(accountId)

    if (!digitalCurrencyAccount.accountId) {
      return
    }

    if (this.openWebsitePageInNewTab) {
      window.open(`${location.origin}/${digitalCurrencyAccount.accountUsername}`, '_blank')!.focus()
    } else {
      const dataTableFileItem = new DataTableFile()
      dataTableFileItem.itemId = digitalCurrencyAccount.accountId
      dataTableFileItem.itemName = digitalCurrencyAccount.accountName
      dataTableFileItem.itemType = itemTypeAccount
      this.$emit('openFolderOrFileItem', dataTableFileItem)
    }
  }

  navigateBackAfterDelete () {
    if (this.openWebsitePageInNewTab) {
      window.open(`${location.origin}`)!.focus()
    } else {
      this.$emit('navigateBackToPreviousFileItem', true)
    }
  }

  async initializeGetIsActiveServiceDaemon () {
    const daemonStatus = await this.serviceInformation1GetServiceInformationByDaemonStatus('daemon-1')
    this.isActiveServiceDaemon = daemonStatus ? daemonStatus.isActive : false

    if (this.isActiveServiceDaemonIntervalId) {
      clearInterval(this.isActiveServiceDaemonIntervalId)
    }

    this.isActiveServiceDaemonIntervalId = setInterval(async () => {
      const daemonStatus = await this.serviceInformation1GetServiceInformationByDaemonStatus('daemon-1')
      this.isActiveServiceDaemon = daemonStatus ? daemonStatus.isActive : false
    }, 1 * NUMBER_OF_MILLISECONDS_IN_A_MINUTE)
  }

  get isPublicTransactionViewing () {
    let isAccountSenderTransaction = this.getActiveDigitalCurrencyAccount.accountId === this.getDigitalCurrencyTransaction(this.transactionId).accountSenderId
    let isAccountRecipientTransaction = false
    let isAccountTransactionOwner = this.getActiveDigitalCurrencyAccount.accountId === this.transactionOwnerAccountId
    if (this.getDigitalCurrencyTransaction(this.transactionId).accountRecipientIdVariableTable) {
      isAccountRecipientTransaction = this.getDigitalCurrencyTransaction(this.transactionId).accountRecipientIdVariableTable[this.getActiveDigitalCurrencyAccount.accountId] ? true : false
    }
    return !isAccountSenderTransaction && !isAccountRecipientTransaction && !isAccountTransactionOwner
  }

  initializeExpectedNumberOfTimesProcessedForSpecialTransactionType () {
    if (!this.transactionId) {
      return
    }

    let digitalCurrencyTransaction = this.getDigitalCurrencyTransaction(this.transactionId)

    if (!digitalCurrencyTransaction) {
      return
    }

    if (!digitalCurrencyTransaction.isRecurringTransaction || !digitalCurrencyTransaction.specialTransactionType) {
      return
    }

    if (this.expectedNumberOfTimesProcessedForSpecialTransactionTypeIntervalId) {
      clearInterval(this.expectedNumberOfTimesProcessedForSpecialTransactionTypeIntervalId)
    }

    this.updateExpectedNumberOfTimesProcessedForSpecialTransactionType(digitalCurrencyTransaction)

    this.expectedNumberOfTimesProcessedForSpecialTransactionTypeIntervalId = setInterval(() => {
      this.updateExpectedNumberOfTimesProcessedForSpecialTransactionType(digitalCurrencyTransaction)
    }, 1000)
  }

  updateExpectedNumberOfTimesProcessedForSpecialTransactionType (digitalCurrencyTransaction: any) {
    const currentDate: number = (new Date()).getTime()
    const { dateTransactionRecurred } = getTransactionProcessingInformationTableAlgorithm.function(digitalCurrencyTransaction)
    const dateAccountCreated: number = this.getDigitalCurrencyAccount(this.transactionOwnerAccountId).dateAccountCreated || 0
    const millisecondSecondDifferenceBetweenAccountCreationAndTransactionProcessingDate = Math.floor(Math.abs(dateAccountCreated - dateTransactionRecurred.getTime()) % (60 * 1000))
    const dateTransactionWillBeApplied = dateAccountCreated - millisecondSecondDifferenceBetweenAccountCreationAndTransactionProcessingDate
    const expectedNumberOfIterations = Math.floor((currentDate - dateTransactionWillBeApplied) / digitalCurrencyTransaction.millisecondRecurringDelay)
    this.expectedNumberOfTimesProcessedForSpecialTransactionType = expectedNumberOfIterations
  }

  get transactionUrl (): string {
    return `${location.origin}/transaction/${this.transactionId}`
  }

  get isAdministratorTransaction (): boolean {
    return this.getDigitalCurrencyTransaction(this.transactionId).specialTransactionType
  }

  get isAdministratorTransactionAndShowNumberOfTimesProcessed () {
    if (this.isAdministratorTransaction) {
      return !this.openWebsitePageInNewTab
    }
    return true
  }

  get isAllRecipientAccountsDeleted (): boolean {
    const isAllRecipientAccountsDeleted = Object.keys(this.getDigitalCurrencyTransaction(this.transactionId).accountRecipientIdVariableTable || {}).map((accountId: string) => this.getDigitalCurrencyTransaction(this.transactionId).accountRecipientIdVariableTable[accountId].dateAccountDeleted || 0).every((dateAccountDeleted: number) => dateAccountDeleted ? true : false)
    return isAllRecipientAccountsDeleted
  }

  get numberOfDeletedRecipientAccounts (): number {
    const numberOfDeletedRecipientAccounts = Object.keys(this.getDigitalCurrencyTransaction(this.transactionId).accountRecipientIdVariableTable || {}).filter((accountId: string) => this.getDigitalCurrencyTransaction(this.transactionId).accountRecipientIdVariableTable[accountId].dateAccountDeleted ? true : false).length
    return numberOfDeletedRecipientAccounts
  }

  getFormattedDate (date: any) {
    return moment(date).format('MMMM DD, YYYY @ hh:mm:ss')
  }

  getTimeAgoSinceDate (date: any) {
    return moment(date).fromNow()
  }
}

export default TransactionHelperComponents2Header
